/**
 * 🧱 Refactor BT Phase 3 — section « SectionZonesCreer » de CreerBonTravailDialog.jsx : JSX déplacé TEL QUEL (ex-L1549-1608, dédenté de 10) ;
 * variables via `useBTForm()` (BTFormProvider enrichi par `extra`). DOM, data-testid, classes, textes inchangés.
 */
import { Button } from '@/components/ui/button';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Input } from '@/components/ui/input';
import { MapPin, Plus, Trash2, Upload, X } from 'lucide-react';
import { Textarea } from '@/components/ui/textarea';
import { useBTForm } from '../../BTFormContext';
import { urlFichier } from '@/lib/fichiers';

export function SectionZonesCreer() {
  const {
    addZone,
    form,
    handleZonePhotoUpload,
    isExt,
    removeZone,
    type,
    updateZone,
    uploadingZone,
  } = useBTForm();
  return (
    <>
      {/* Zones (extérieur seulement) */}
      {isExt && (
        <Card className="border-green-200">
          <CardHeader>
            <div className="flex justify-between items-center">
              <CardTitle className="text-base flex items-center gap-2"><MapPin className="w-4 h-4 text-green-600" /> Zones à Travailler</CardTitle>
              <Button type="button" size="sm" variant="outline" onClick={addZone} data-testid="btn-add-zone"><Plus className="w-3 h-3 mr-1" /> Ajouter une zone</Button>
            </div>
          </CardHeader>
          <CardContent>
            {form.zones.length === 0 ? (
              <p className="text-center text-gray-400 py-4 text-sm">Aucune zone ajoutée</p>
            ) : (
              <div className="grid grid-cols-2 gap-4">
                {form.zones.map((zone, idx) => (
                  // ✅ FIX 2026-04-27: clé stable (pas JSON.stringify, sinon perte de focus)
                  <div key={zone.id || zone._id || `zone-${idx}`} className="border rounded-lg p-3 bg-green-50/30">
                    <div className="flex justify-between items-center mb-2">
                      <span className="bg-green-600 text-white rounded-full w-7 h-7 flex items-center justify-center text-xs font-bold">Z{zone.numero}</span>
                      <Button type="button" variant="ghost" size="sm" onClick={() => removeZone(idx)}><Trash2 className="w-3.5 h-3.5 text-red-500" /></Button>
                    </div>
                    <Input value={zone.nom} onChange={(e) => updateZone(idx, 'nom', e.target.value)} placeholder={`Nom zone ${zone.numero}...`} className="mb-2 h-8 text-sm" />
                    <Textarea
                      value={zone.description || ''}
                      onChange={(e) => updateZone(idx, 'description', e.target.value)}
                      placeholder="Détails sur cette zone..."
                      rows={2}
                      className="mb-2 text-xs"
                    />
                    {zone.photo_url ? (
                      <div className="relative">
                        <img src={urlFichier(zone.photo_url)} alt={`Zone ${zone.numero}`} className="w-full h-28 object-cover rounded" />
                        <button onClick={() => updateZone(idx, 'photo_url', null)} className="absolute top-1 right-1 bg-red-500 text-white rounded-full p-0.5"><X className="w-3 h-3" /></button>
                      </div>
                    ) : (
                      <div>
                        <div 
                          className="text-center py-4 border-2 border-dashed rounded-lg hover:border-green-400 hover:bg-green-50 transition-colors cursor-pointer"
                          onClick={() => document.getElementById(`zone-upload-${idx}`).click()}
                        >
                          {uploadingZone === idx ? (
                            <div className="animate-spin rounded-full h-6 w-6 border-b-2 border-green-600 mx-auto" />
                          ) : (
                            <>
                              <Upload className="w-5 h-5 mx-auto mb-1 text-gray-400" />
                              <p className="text-xs text-gray-400">Cliquer pour uploader</p>
                            </>
                          )}
                        </div>
                        <input id={`zone-upload-${idx}`} type="file" accept="image/*" style={{ display: 'none' }} onChange={(e) => { if (e.target.files?.[0]) handleZonePhotoUpload(idx, e.target.files[0]); e.target.value = ''; }} />
                      </div>
                    )}
                  </div>
                ))}
              </div>
            )}
          </CardContent>
        </Card>
      )}

    </>
  );
}
